export const GET_PERMISSIONS_LIST = 'GET_PERMISSIONS_LIST';
export const GET_ROLES_LIST = 'GET_ROLES_LIST';
export const SET_LISTS = 'SET_LISTS';
export const SET_CATALOGS_LIST = 'SET_CATALOGS_LIST';



// WEBPACK FOOTER //
// src/containers/lists/constants.js